/* ISG personaliser, part 3 of 5 (built by tools/split.js from isg-personaliser.js md5 aceaaca6061588d0d715ab3ec4d20473; load after part 2). */
(function (root) {
  'use strict';
  var NS = root.__isgPz;
  if (!NS || NS.__parts !== 2) { if (root.console) root.console.error('ISG personaliser: part 3 loaded before part 2'); return; }
  var money = NS.money, round1 = NS.round1, stageBounds = NS.stageBounds, garmentFit = NS.garmentFit, parseCmPair = NS.parseCmPair, parseSizedPairs = NS.parseSizedPairs, bagPlace = NS.bagPlace, endPlace = NS.endPlace, headwearFit = NS.headwearFit, legFit = NS.legFit, hivisFit = NS.hivisFit, apronFit = NS.apronFit, bagFit = NS.bagFit, chestZone = NS.chestZone, pctBoxToCm = NS.pctBoxToCm, backFromFront = NS.backFromFront, sleeveFromFront = NS.sleeveFromFront, DEFAULT_FONTS = NS.DEFAULT_FONTS, DEFAULT_COLOURS = NS.DEFAULT_COLOURS, parseFonts = NS.parseFonts, parseColours = NS.parseColours, printsPrice = NS.printsPrice, parseSizeScale = NS.parseSizeScale, parseTiers = NS.parseTiers, scaleLookup = NS.scaleLookup, effectiveTier = NS.effectiveTier, calibrationStatus = NS.calibrationStatus, garmentZone = NS.garmentZone, placementVerified = NS.placementVerified, doc = NS.doc, LETTERS = NS.LETTERS, el = NS.el, loadImage = NS.loadImage;


  function Personaliser(container) {
    var id = container.getAttribute('data-isg-pz');
    this.data = JSON.parse(doc.getElementById('IsgPzData-' + id).textContent);
    this.c = container;
    this.q = function (sel) { return container.querySelector(sel); };
    var self = this, d = this.data;
    // Bags: every product has its own print area and size (product fields), used on every side that isn't a sleeve.
    this.bagMode = (d.settings.fitMode || '') === 'bag';
    // Long-sleeved tops photographed with the arms hanging beside the body (sweatshirts): see garmentFit.
    // Hoodies are long-sleeved too, and their print area starts below the hood.
    this.hood = (d.settings.fitMode || '') === 'garment-hood';
    this.longSleeve = this.hood || (d.settings.fitMode || '') === 'garment-long';
    // Caps and beanies: the print area is placed on the product outline in each photo (see headwearFit). A product's
    // own Print area (cm) field, when set, replaces the template's print area size.
    this.headwear = /^(cap|beanie|bucket|visor)$/.test(d.settings.fitMode || '') ? d.settings.fitMode : null;
    // Trousers and shorts: a print area on each leg below the crotch, measured on each photo (see legFit).
    this.legs = (d.settings.fitMode || '') === 'legs';
    // Hi-vis tops: chest print areas placed on clear fabric off the reflective tape, measured on each photo (see
    // hivisFit). 'hivis' sleeveless (vests, tabards), 'hivis-top' short sleeves, 'hivis-long' long sleeves and hoods.
    this.hivis = /^hivis(-top|-long)?$/.test(d.settings.fitMode || '') ? d.settings.fitMode : null;
    // Aprons: the print area is placed on the bib or below the waistband, measured on each photo (see apronFit).
    this.apron = (d.settings.fitMode || '') === 'apron';
    if (this.headwear) {
      var hpa = parseCmPair(d.productArea);
      if (hpa) d.sides.forEach(function (s) {
        if (s.sleeve === 'left' || s.sleeve === 'right') return;
        s.areaW = hpa.w; s.areaH = hpa.h;
        if (s.defaultW) s.defaultW = Math.min(s.defaultW, hpa.w);
      });
    }
    this.bag = null;
    this.endPanel = null;     // holdall ends: { size, round } (bag mode, sides with panel "end")
    this.bagSizes = null;    // bags sold in several sizes: { SIZE: { area, size } }
    if (this.bagMode) {
      var areaMap = parseSizedPairs(d.productArea), sizeMap = parseSizedPairs(d.productSize);
      var pa = areaMap ? null : parseCmPair(d.productArea), ps = sizeMap ? null : parseCmPair(d.productSize);
      if (areaMap) {
        // The preview is set up on the biggest size; smaller sizes get the design scaled down to fit (same price).
        var ref = Object.keys(areaMap).sort(function (a, b) { return areaMap[b].w * areaMap[b].h - areaMap[a].w * areaMap[a].h; })[0];
        pa = areaMap[ref];
        ps = sizeMap && sizeMap[ref] ? sizeMap[ref] : ps;
        this.bagSizes = {};
        for (var sk in areaMap) this.bagSizes[sk] = { area: areaMap[sk], size: sizeMap && sizeMap[sk] };
        this.bagRef = ref;
      }
      // Bag ends (holdalls): their own print area and panel size (product fields), else the template's values.
      var ea = parseCmPair(d.productEndArea), es = parseCmPair(d.productEndSize);
      d.sides.forEach(function (s) {
        if (s.panel === 'end') {
          if (ea) { s.areaW = ea.w; s.areaH = ea.h; }
          if (es) { s.areaW = Math.min(s.areaW, es.w); s.areaH = Math.min(s.areaH, es.h); }
          if (s.defaultW) s.defaultW = Math.min(s.defaultW, s.areaW);
          return;
        }
        if (s.sleeve === 'left' || s.sleeve === 'right' || !pa) return;
        s.areaW = pa.w; s.areaH = pa.h;
        if (s.defaultW) s.defaultW = Math.min(s.defaultW, pa.w);
      });
      var e0 = d.sides.filter(function (s) { return s.panel === 'end'; })[0];
      // Without an end size, assume a 3 cm margin round the end print area. "round" in the size field draws a round end (barrels).
      if (e0) this.endPanel = { size: es || { w: e0.areaW + 6, h: e0.areaH + 6 }, round: /round/i.test(d.productEndSize || '') };
      var sa = d.sides[0] ? { w: d.sides[0].areaW, h: d.sides[0].areaH } : null;
      // Without a product size, assume the print area is the bag less the usual margins (3 cm sides, 4 cm top and bottom).
      if (sa) this.bag = { size: ps || { w: sa.w + 6, h: sa.h + 8 }, area: sa, vpos: (d.settings.bagVpos == null ? 50 : d.settings.bagVpos) / 100 };
    }
    this.sizesByKey = {};
    d.sizes.forEach(function (s) { self.sizesByKey[s.key] = s; });
    this.sidesByKey = {};
    d.sides.forEach(function (s) { self.sidesByKey[s.key] = s; });
    this.sizeScale = parseSizeScale(d.settings.sizeScale);
    if (this.bagSizes && d.sides[0]) {
      // Widest print per bag size, so every size's print fits both ways (the same scaling the garments use).
      var s0 = d.sides[0], scale = {};
      for (var bk in this.bagSizes) {
        var ba = this.bagSizes[bk].area;
        scale[bk] = Math.round(s0.areaW * Math.min(1, ba.w / s0.areaW, ba.h / s0.areaH) * 10) / 10;
      }
      this.sizeScale = scale;
      if (!d.settings.referenceSize) d.settings.referenceSize = this.bagRef;
    }
    this.tiers = parseTiers(d.settings.bulkTiers);
    // Calibration (review point 3): real garment figures, or an estimated scale that is flagged as such.
    this.calib = calibrationStatus(d.settings);
    this.calibValues = this.calib === 'calibrated' ? { garmentWidthCm: parseFloat(d.settings.garmentWidthCm), collarToPrintCm: parseFloat(d.settings.collarToPrintCm) } : null;
    // Placement verification gate: unverified placements are not orderable automatically (mode "mockup"), unless ISG
    // switches the template to mode "order", in which case orders carry the placement status for the mock-up stage.
    this.placement = d.placement || {};
    if (this.placement.mode !== 'order') this.placement.mode = 'mockup';
    this.pendingRefs = this.loadPendingRefs();   // design-ref bases of attempts that may have left lines in the basket
    this.designs = [];
    this.activeDesign = null;
    this.rows = [];           // [{ colour, designId, qty: { size: n } }]
    this.sizeCache = {};      // colour -> sizeValues
    this.loading = {};        // colour -> true while sizes load
    this.nextUid = 1;
    this.activeSide = d.sides.length ? d.sides[0].key : null;
    this.selectedPrint = null;
    this.busy = false;
    this.stageAspect = 1200 / 1440;
    this.fits = {};           // photo src -> measured print area (or null)
    this.lastFit = null;      // last good measurement, used for photos that can't be measured
    this.currentSrc = null;
    var tx = d.text || {};
    this.textOn = tx.enabled !== false;
    this.fonts = parseFonts(tx.fonts || DEFAULT_FONTS);
    if (!this.fonts.length) this.fonts = parseFonts(DEFAULT_FONTS);
    this.colours = parseColours(tx.colours || DEFAULT_COLOURS);
    if (!this.colours.length) this.colours = parseColours(DEFAULT_COLOURS);
    this.fontsReady = null;   // promise: Google Fonts stylesheet loaded
    this.backViews = {};      // front photo src -> back view (data URL), 'failed', or 'pending'
    this.backPromises = {};
    this.sleeveViews = {};    // 'left|' / 'right|' + front photo src -> sleeve close-up (data URL), 'failed', or 'pending'
    this.sleevePromises = {};
    this.init();
  }

  Personaliser.prototype.init = function () {
    var self = this, d = this.data;
    var selected = d.colours.filter(function (c) { return c.selected; })[0] || d.colours[0];
    if (selected) this.sizeCache[selected.name] = d.sizeValues;
    this.previewColour = selected ? selected.name : null;

    this.addDesign();
    if (selected && d.variantInUrl) this.addRow(selected.name);

    this.renderSideTabs();
    this.renderSwatches();
    this.renderRows();
    this.renderSizeGuide();
    this.q('[data-pz-add-print]').addEventListener('click', function () { self.addPrint(); });
    var addText = this.q('[data-pz-add-text]');
    if (addText) {
      if (this.textOn) addText.addEventListener('click', function () { self.addTextPrint(); });
      else addText.hidden = true;
    }
    this.q('[data-pz-submit]').addEventListener('click', function () { self.submit(); });
    var email = this.q('[data-pz-email]');
    if (email) email.addEventListener('input', function () { self.update(); });

    var garment = this.q('[data-pz-garment]');
    garment.crossOrigin = 'anonymous';
    garment.addEventListener('load', function () {
      if (garment.naturalWidth && garment.naturalHeight) {
        self.stageAspect = garment.naturalWidth / garment.naturalHeight;
        self.q('[data-pz-stage]').style.aspectRatio = garment.naturalWidth + ' / ' + garment.naturalHeight;
        var src = garment.getAttribute('src');
        var act = self.sidesByKey[self.activeSide];
        if (src && !(src in self.fits)) self.fits[src] = self.measure(garment, act);
        if (self.fits[src] && !self.isSleeve(act) && !self.isEnd(act)) self.lastFit = self.fits[src];
        if (!self.fits[src] && !self.lastFit && (self.bagMode || self.headwear || self.legs || self.hivis || self.apron)) self.referenceFit();
        self.layoutZone();
        self.renderPreviewPrints();
      }
    });
    garment.addEventListener('error', function () {
      // If the photo can't be read for measuring, show it normally and use the template's print area.
      if (garment.crossOrigin) { var src = garment.getAttribute('src'); self.fits[src] = null; garment.removeAttribute('crossorigin'); garment.src = src; }
    });
    root.addEventListener('beforeunload', function (e) {
      if (self.busy) { e.preventDefault(); e.returnValue = ''; }
    });
    if (!d.sizes.some(function (s) { return s.variantId; })) {
      this.showError('Print pricing is not set up yet, so personalised items cannot be added to the basket. Please contact us to order.');
    }
    this.showSide(this.activeSide);
    this.update();
  };

  /* ----- Lookups ----- */

  Personaliser.prototype.colourInfo = function (colour) {
    return this.data.colours.filter(function (c) { return c.name === colour; })[0] || null;
  };
  Personaliser.prototype.design = function (id) {
    return this.designs.filter(function (x) { return x.id === id; })[0] || null;
  };
  Personaliser.prototype.currentDesign = function () { return this.design(this.activeDesign); };
  Personaliser.prototype.findPrint = function (uid) {
    var found = null;
    this.designs.forEach(function (dz) { dz.prints.forEach(function (p) { if (p.uid === uid) found = p; }); });
    return found;
  };
  Personaliser.prototype.row = function (colour) {
    return this.rows.filter(function (r) { return r.colour === colour; })[0] || null;
  };
  Personaliser.prototype.sizeMaxWidth = function (sizeName) {
    return scaleLookup(this.sizeScale, sizeName) || null;
  };

  Personaliser.prototype.isSleeve = function (side) { return !!side && (side.sleeve === 'left' || side.sleeve === 'right'); };
  Personaliser.prototype.isChest = function (side) { return !!side && !this.bagMode && (side.chest === 'left' || side.chest === 'right'); };

  // The body width (side seam to side seam) in cm that a measured photo stands for: the calibrated garment width when
  // ISG has measured it, else the legacy "body width" setting, else the Front print area width (an estimate). Sets the
  // cm scale for sleeves and chest prints.
  Personaliser.prototype.bodyW = function () {
    if (this.calibValues) return this.calibValues.garmentWidthCm;
    var front = this.data.sides.filter(function (s) { return s.view === 'front'; })[0];
    return this.data.settings.bodyWidthCm || (front && front.areaW) || 34;
  };

  // Print positions used by the designs that are on ordered lines (for the verification gate).
  Personaliser.prototype.usedSideKeys = function () {
    var keys = {};
    this.usedDesigns().forEach(function (dz) { dz.prints.forEach(function (p) { keys[p.side] = true; }); });
    return Object.keys(keys);
  };

  // Can this product be ordered automatically? Only with a verified placement, or when ISG set the template to order mode.
  Personaliser.prototype.isVerified = function () {
    return placementVerified(this.data, this.usedSideKeys(), this.calib);
  };
  Personaliser.prototype.orderMode = function () {
    return this.isVerified() || this.placement.mode === 'order' ? 'order' : 'mockup';
  };
  Personaliser.prototype.placementStatusText = function () {
    if (this.isVerified()) return 'verified by ISG';
    return this.calib === 'calibrated' ? 'measured scale, placement not yet verified by ISG – check on the mock-up'
      : 'standard preset, not measured – check on the mock-up';
  };

  // Design-ref bases of attempts that may have left lines in the basket (review point 5), kept for this tab's session.
  Personaliser.prototype.loadPendingRefs = function () {
    try { return JSON.parse(root.sessionStorage.getItem('isgPzPending') || '[]').filter(function (x) { return typeof x === 'string'; }).slice(-10); } catch (e) { return []; }
  };
  Personaliser.prototype.savePendingRefs = function () {
    try { root.sessionStorage.setItem('isgPzPending', JSON.stringify(this.pendingRefs)); } catch (e) { /* storage unavailable: kept in memory only */ }
  };
  Personaliser.prototype.isEnd = function (side) { return !!(this.bagMode && this.endPanel && side && side.panel === 'end'); };

  // A real product image for this view (alt text "<view>:<Colour>"), if there is one.
  Personaliser.prototype.realViewImage = function (side, colour) {
    var lc = (colour || '').toLowerCase().trim();
    var match = this.data.viewImages.filter(function (m) {
      var parts = m.alt.split(':');
      return parts[0].trim().toLowerCase() === side.view && parts.slice(1).join(':').trim().toLowerCase() === lc;
    })[0];
    return match ? match.src : null;
  };

  // Which view this side makes from the colour's front photo when there's no real photo: 'back', 'left', 'right' or null.
  Personaliser.prototype.madeFrom = function (side) {
    if (!side || side.useVariantImage) return null;
    if (this.isSleeve(side)) return side.sleeve;
    return side.backFromFront ? 'back' : null;
  };
  Personaliser.prototype.madeView = function (kind, front) {
    return kind === 'back' ? this.backViews[front] : this.sleeveViews[kind + '|' + front];
  };
  Personaliser.prototype.requestMade = function (kind, side, front) {
    return kind === 'back' ? this.requestBack(front) : this.requestSleeve(kind, side, front);
  };

  Personaliser.prototype.viewImage = function (side, colour) {
    colour = colour || this.previewColour;
    var real = this.realViewImage(side, colour);
    if (real) return real;
    var info = this.colourInfo(colour);
    if (side.useVariantImage) return info && info.image ? info.image : null;
    var kind = this.madeFrom(side);
    if (kind && info && info.image) {
      var b = this.madeView(kind, info.image);
      if (b === undefined) this.requestMade(kind, side, info.image);
      if (b && b.indexOf('data:') === 0) return b;
      // the back falls back to the front photo; a sleeve shows the print-area plan instead
      return kind === 'back' ? info.image : null;
    }
    return null;
  };

  // How the photo for this view was made, for the caption: '' (a real photo), 'made', 'pending' or 'front' (could not be made).
  Personaliser.prototype.viewKind = function (side, colour) {
    colour = colour || this.previewColour;
    var kind = this.madeFrom(side);
    if (!kind || this.realViewImage(side, colour)) return '';
    var info = this.colourInfo(colour);
    if (!info || !info.image) return '';
    var b = this.madeView(kind, info.image);
    return b === 'failed' ? 'front' : b && b.indexOf('data:') === 0 ? 'made' : 'pending';
  };

  // Make the back view for a colour from its front photo (once per photo). Resolves when ready or failed.
  Personaliser.prototype.requestBack = function (front) {
    var self = this;
    if (this.backPromises[front]) return this.backPromises[front];
    this.backViews[front] = 'pending';
    this.backPromises[front] = loadImage(front, true).then(function (img) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(img); }, 0); });
    }).then(function (img) {
      var W = Math.min(600, img.naturalWidth), H = Math.max(1, Math.round(W * img.naturalHeight / img.naturalWidth));
      var c = doc.createElement('canvas'); c.width = W; c.height = H;
      var ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, W, H);
      var r = backFromFront(ctx.getImageData(0, 0, W, H).data, W, H);
      if (!r) return null;
      // Draw only the changed neck area over the full-size photo, so the rest stays exactly as supplied.
      var ov = doc.createElement('canvas'); ov.width = W; ov.height = H;
      var oc = ov.getContext('2d'), id = oc.createImageData(W, H);
      id.data.set(r.overlay); oc.putImageData(id, 0, 0);
      var full = doc.createElement('canvas'); full.width = img.naturalWidth; full.height = img.naturalHeight;
      var fc = full.getContext('2d');
      fc.drawImage(img, 0, 0);
      fc.imageSmoothingEnabled = true; fc.imageSmoothingQuality = 'high';
      fc.drawImage(ov, 0, 0, full.width, full.height);
      return full.toDataURL('image/jpeg', 0.9);
    }).catch(function () { return null; }).then(function (url) {
      self.backViews[front] = url || 'failed';
      var side = self.sidesByKey[self.activeSide];
      if (self.madeFrom(side) === 'back') self.showSide(self.activeSide);
      return url;
    });
    return this.backPromises[front];
  };

  // Make a close-up of one sleeve from a colour's front photo (once per photo and sleeve).
  // The print area is placed on the sleeve at the same scale as the front, so 15 cm there matches 15 cm on the chest.
  Personaliser.prototype.requestSleeve = function (which, side, front) {
    var self = this, key = which + '|' + front;
    if (this.sleevePromises[key]) return this.sleevePromises[key];
    this.sleeveViews[key] = 'pending';
    this.sleevePromises[key] = loadImage(front, true).then(function (img) {
      var W = Math.min(600, img.naturalWidth), H = Math.max(1, Math.round(W * img.naturalHeight / img.naturalWidth));
      var c = doc.createElement('canvas'); c.width = W; c.height = H;
      var ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, W, H);
      var r = sleeveFromFront(ctx.getImageData(0, 0, W, H).data, W, H, which, self.bodyW(), side.areaW, side.areaH, { longSleeve: self.longSleeve });
      if (!r) return null;
      // cut the close-up from the full-size photo, unchanged; any margin past the photo edge is its background colour
      var k = img.naturalWidth / W;
      var out = doc.createElement('canvas');
      out.width = Math.round(r.crop.w * k); out.height = Math.round(r.crop.h * k);
      var oc = out.getContext('2d');
      oc.fillStyle = r.bg; oc.fillRect(0, 0, out.width, out.height);
      oc.drawImage(img, -r.crop.x * k, -r.crop.y * k);
      var url = out.toDataURL('image/jpeg', 0.92);
      self.fits[url] = { zoneLeft: r.zone.zoneLeft, zoneTop: r.zone.zoneTop, zoneWidth: r.zone.zoneWidth, box: r.box };
      return url;
    }).catch(function () { return null; }).then(function (url) {
      self.sleeveViews[key] = url || 'failed';
      var act = self.sidesByKey[self.activeSide];
      if (self.madeFrom(act) === which) self.showSide(self.activeSide);
      return url;
    });
    return this.sleevePromises[key];
  };

  // Lines to order: one per colour + size with a quantity.
  Personaliser.prototype.lines = function () {
    var self = this, out = [];
    this.rows.forEach(function (r) {
      (self.sizeCache[r.colour] || []).forEach(function (sv) {
        var q = r.qty[sv.name] || 0;
        if (q > 0 && sv.variant) out.push({ colour: r.colour, size: sv.name, qty: q, variant: sv.variant, price: sv.variant.price, designId: r.designId });
      });
    });
    return out;
  };

  /* ----- Step 1: colours and sizes ----- */

  Personaliser.prototype.renderSwatches = function () {
    var self = this, wrap = this.q('[data-pz-colours]');
    wrap.innerHTML = '';
    this.data.colours.forEach(function (c, i) {
      var inputId = 'PzColour-' + self.data.sectionId + '-' + i;
      var input = el('input', { type: 'checkbox', id: inputId, value: c.name, class: 'visually-hidden', checked: !!self.row(c.name) });
      input.addEventListener('change', function () {
        if (input.checked) self.addRow(c.name); else self.removeRow(c.name);
      });
      wrap.appendChild(input);
      wrap.appendChild(el('label', { for: inputId, class: 'isg-pz__swatch', title: c.name }, [
        c.thumb ? el('img', { src: c.thumb, alt: '', width: '48', height: '58', loading: 'lazy' }) : el('span', { class: 'isg-pz__swatch-blank' }),
        el('span', { class: 'visually-hidden', text: c.name })
      ]));
    });
  };

  Personaliser.prototype.syncSwatches = function () {
    var self = this;
    Array.prototype.forEach.call(this.c.querySelectorAll('[data-pz-colours] input'), function (i) { i.checked = !!self.row(i.value); });
  };

  Personaliser.prototype.addRow = function (colour) {
    if (this.row(colour)) return;
    var self = this;
    this.rows.push({ colour: colour, designId: this.activeDesign, qty: {} });
    this.previewColour = colour;
    this.syncSwatches();
    this.renderRows();
    this.showSide(this.activeSide);
    this.update();
    if (!this.sizeCache[colour]) {
      this.loading[colour] = true;
      this.renderRows();
      this.update();
      this.fetchSizes(colour).then(function (list) {
        self.sizeCache[colour] = list;
      }).catch(function () {
        self.showError('We could not load sizes for ' + colour + '. Please check your connection, then remove and add the colour again.');
      }).then(function () {
        delete self.loading[colour];
        self.renderRows();
        self.update();
      });
    }
    this.announce(colour + ' added. Enter quantities for each size.');
  };

  Personaliser.prototype.removeRow = function (colour) {
    this.rows = this.rows.filter(function (r) { return r.colour !== colour; });
    if (this.previewColour === colour && this.rows.length) this.previewColour = this.rows[0].colour;
    this.syncSwatches();
    this.renderRows();
    this.showSide(this.activeSide);
    this.update();
    this.announce(colour + ' removed.');
  };

  Personaliser.prototype.fetchSizes = function (colour) {
    var d = this.data, info = this.colourInfo(colour);
    var url = d.productUrl + (d.productUrl.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(d.sectionId) +
      '&option_values=' + encodeURIComponent(info.id) + (d.templateSuffix ? '&view=' + encodeURIComponent(d.templateSuffix) : '');
    return fetch(url, { headers: { Accept: 'text/html' } }).then(function (r) {
      if (!r.ok) throw new Error('sizes');
      return r.text();
    }).then(function (html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var node = parsed.getElementById('IsgPzData-' + d.sectionId);
      if (!node) throw new Error('sizes');
      var data = JSON.parse(node.textContent);
      var sel = data.colours.filter(function (c) { return c.selected; })[0];
      if (!sel || sel.name !== colour) throw new Error('sizes');
      return data.sizeValues;
    });
  };

  Personaliser.prototype.renderRows = function () {
    var self = this, d = this.data, wrap = this.q('[data-pz-rows]');
    wrap.innerHTML = '';
    if (!this.rows.length) {
      wrap.appendChild(el('p', { class: 'isg-pz__hint', text: 'Tap one or more colours above to start.' }));
      return;
    }
    this.rows.forEach(function (r, ri) {
      var info = self.colourInfo(r.colour);
      var card = el('div', { class: 'isg-pz-row' + (self.previewColour === r.colour ? ' is-previewing' : ''), 'data-colour': r.colour });
      var head = el('div', { class: 'isg-pz-row__head' }, [
        info && info.thumb ? el('img', { src: info.thumb, alt: '', class: 'isg-pz-row__thumb', width: '36', height: '43' }) : null,
        el('h3', { class: 'isg-pz-row__title', text: r.colour }),
        el('button', { type: 'button', class: 'isg-pz-row__btn', 'aria-pressed': self.previewColour === r.colour ? 'true' : 'false', onclick: function () { self.setPreviewColour(r.colour); } }, ['Preview']),
        el('button', { type: 'button', class: 'isg-pz-row__btn isg-pz-row__remove', 'aria-label': 'Remove ' + r.colour, onclick: function () { self.removeRow(r.colour); } }, ['Remove'])
      ]);
      card.appendChild(head);

      if (self.designs.length > 1) {
        var selId = 'PzRowDesign-' + d.sectionId + '-' + ri;
        var sel = el('select', { id: selId, class: 'isg-pz__select isg-pz-row__design' });
        self.designs.forEach(function (dz) { sel.appendChild(el('option', { value: dz.id, selected: dz.id === r.designId }, ['Design ' + dz.id])); });
        sel.addEventListener('change', function () { r.designId = sel.value; self.update(); if (self.previewColour === r.colour) self.setActiveDesign(r.designId); });
        card.appendChild(el('div', { class: 'isg-pz-row__designline' }, [el('label', { for: selId, text: 'Design for ' + r.colour + ':' }), sel]));
      }

      if (self.loading[r.colour]) {
        card.appendChild(el('p', { class: 'isg-pz__hint', text: 'Loading sizes for ' + r.colour + '…' }));
      } else {
        var list = self.sizeCache[r.colour] || [];
        var base = null;
        list.forEach(function (sv) { if (sv.variant && base === null) base = sv.variant.price; });
        var grid = el('div', { class: 'isg-pz-row__grid', role: 'group', 'aria-label': 'Quantities for ' + r.colour });
        list.forEach(function (sv, si) {
          var v = sv.variant;
          if (!v) return;
          var inputId = 'PzQty-' + d.sectionId + '-' + ri + '-' + si;
          var max = v.stock != null ? Math.max(v.stock, 0) : null;
          if (v.qtyMax && (max == null || v.qtyMax < max)) max = v.qtyMax;
          var input = el('input', {
            type: 'number', id: inputId, min: '0', step: '1', inputmode: 'numeric', class: 'isg-pz-row__qty',
            value: r.qty[sv.name] ? String(r.qty[sv.name]) : '', placeholder: '0', disabled: !v.available,
            max: max != null ? String(max) : null
          });
          input.addEventListener('input', function () {
            var n = parseInt(input.value, 10);
            if (!n || n < 0) n = 0;
            if (max != null && n > max) { n = max; input.value = String(max); self.announce('Only ' + max + ' of ' + r.colour + ' ' + sv.name + ' available.'); }
            if (n) r.qty[sv.name] = n; else delete r.qty[sv.name];
            self.updateRowTotal(r, card);
            self.update();
          });
          var note = !v.available ? 'Sold out' : (v.price !== base ? money(v.price, d.currency) : '');
          if (v.available && v.stock != null && v.stock < 10) note = (note ? note + ' · ' : '') + v.stock + ' left';
          grid.appendChild(el('div', { class: 'isg-pz-row__cell' + (v.available ? '' : ' is-unavailable') }, [
            el('label', { for: inputId, class: 'isg-pz-row__size', text: sv.name }),
            input,
            el('span', { class: 'isg-pz-row__note', text: note })
          ]));
        });
        card.appendChild(grid);
        card.appendChild(el('p', { class: 'isg-pz-row__total', 'data-row-total': '' }));
        self.updateRowTotal(r, card);
      }
      wrap.appendChild(card);
    });
  };

  Personaliser.prototype.updateRowTotal = function (r, card) {
    var n = card.querySelector('[data-row-total]');
    if (!n) return;
    var count = 0, cost = 0;
    (this.sizeCache[r.colour] || []).forEach(function (sv) {
      var q = r.qty[sv.name] || 0;
      if (q && sv.variant) { count += q; cost += q * sv.variant.price; }
    });
    var dz = this.design(r.designId);
    var pp = dz ? printsPrice(dz.prints, this.sizesByKey) : 0;
    n.textContent = count ? count + ' × ' + r.colour + (this.designs.length > 1 ? ' with Design ' + r.designId : '') + ': ' + money(cost + pp * count, this.data.currency) + ' including prints' : '';
  };

  Personaliser.prototype.setPreviewColour = function (colour) {
    this.previewColour = colour;
    var r = this.row(colour);
    if (r && r.designId !== this.activeDesign) this.setActiveDesign(r.designId, true);
    this.renderRows();
    this.showSide(this.activeSide);
  };

  /* ----- Designs ----- */

  Personaliser.prototype.addDesign = function (copyFrom) {
    var used = this.designs.map(function (x) { return x.id; });
    var id = LETTERS.split('').filter(function (l) { return used.indexOf(l) === -1; })[0];
    var self = this;
    var dz = { id: id, prints: [] };
    if (copyFrom) {
      copyFrom.prints.forEach(function (p) {
        var c = { uid: 'p' + self.nextUid++, side: p.side, sizeKey: p.sizeKey, art: p.art, x: p.x, y: p.y, w: p.w, h: p.h, rot: p.rot || 0, kind: p.kind || 'image',
                  text: p.text ? Object.assign({}, p.text) : null, error: null, ppi: p.ppi, resLevel: p.resLevel };
        dz.prints.push(c);
      });
    }
    this.designs.push(dz);
    this.activeDesign = id;
    if (!copyFrom) this.addPrint(true);
    return dz;
  };

  Personaliser.prototype.removeDesign = function (id) {
    if (this.designs.length < 2) return;
    this.designs = this.designs.filter(function (x) { return x.id !== id; });
    var fallback = this.designs[0].id;
    this.rows.forEach(function (r) { if (r.designId === id) r.designId = fallback; });
    this.setActiveDesign(fallback);
    this.renderRows();
    this.announce('Design ' + id + ' removed. Colours that used it now use Design ' + fallback + '.');
  };

  Personaliser.prototype.setActiveDesign = function (id, keepColour) {
    this.activeDesign = id;
    if (!keepColour) {
      var r = this.rows.filter(function (x) { return x.designId === id; })[0];
      if (r) this.previewColour = r.colour;
    }
    this.renderDesignTabs();
    this.renderPrintCards();
    this.renderRows();
    this.showSide(this.activeSide);
    this.update();
  };

  Personaliser.prototype.renderDesignTabs = function () {
    var self = this, wrap = this.q('[data-pz-designtabs]');
    wrap.innerHTML = '';
    this.designs.forEach(function (dz) {
      wrap.appendChild(el('button', {
        type: 'button', class: 'isg-pz__designtab', 'aria-pressed': dz.id === self.activeDesign ? 'true' : 'false',
        onclick: function () { self.setActiveDesign(dz.id); }
      }, ['Design ' + dz.id]));
    });
    wrap.appendChild(el('button', {
      type: 'button', class: 'isg-pz__designtab isg-pz__designtab--add',
      onclick: function () { self.addDesign(self.currentDesign()); self.setActiveDesign(self.activeDesign, true); self.announce('Design ' + self.activeDesign + ' added as a copy. Replace the artwork for this version.'); }
    }, ['+ Add a different design']));
    var dz = this.currentDesign();
    var users = this.rows.filter(function (r) { return r.designId === dz.id; }).map(function (r) { return r.colour; });
    var note = this.q('[data-pz-design-note]');
    note.innerHTML = '';
    if (this.designs.length > 1) {
      note.appendChild(el('span', { text: 'Design ' + dz.id + ' is used on: ' + (users.length ? users.join(', ') : 'no colours yet – choose it for a colour in step 1') + '. ' }));
      note.appendChild(el('button', { type: 'button', class: 'isg-pz-print__remove link', onclick: function () { self.removeDesign(dz.id); } }, ['Remove Design ' + dz.id]));
    } else {
      note.appendChild(el('span', { text: 'Need a different design on some colours (for example a white version for dark shirts)? Use “Add a different design”.' }));
    }
  };

  Personaliser.prototype.renderSizeGuide = function () {
    var self = this, sides = this.data.sides;
    var prev = null;
    var parts = this.data.sizes.filter(function (s) { return s.price != null; }).map(function (s) {
      var w = 0, h = 0;
      sides.forEach(function (sd) { if (self.allowed(sd.key, s)) { var e = effectiveTier(s, sd); w = Math.max(w, e.w); h = Math.max(h, e.h); } });
      if (!w) { w = s.maxW; h = s.maxH; }
      // On a small print area a bigger size can come out no bigger than the one before; it's never charged, so don't list it.
      if (prev && w <= prev.w && h <= prev.h) return null;
      prev = { w: w, h: h };
      return s.label + ' (up to ' + w + ' × ' + h + ' cm) +' + money(s.price, self.data.currency);
    }).filter(Boolean);
    var txt = 'Add as many prints as you like' + (this.textOn ? ' – your own artwork or text –' : '') + ' and place them anywhere inside the dashed print area. Print sizes and prices per ' + (this.bagMode ? 'bag' : 'garment') + ': ' + parts.join(' · ') + '. The print size is set automatically by how big you make your artwork.';
    var limited = sides.filter(function (sd) { return String(sd.allowedSizes || '').trim(); });
    // group sides offering the same sizes: "Left sleeve and Right sleeve prints are Medium."
    var groups = [], byOffer = {};
    limited.forEach(function (sd) {
      var offer = self.data.sizes.filter(function (s) { return self.allowed(sd.key, s); }).map(function (s) { return s.label; }).join(' or ');
      if (!byOffer[offer]) { byOffer[offer] = []; groups.push(offer); }
      byOffer[offer].push(sd.name);
    });
    if (groups.length) txt += ' ' + groups.map(function (offer) {
      var n = byOffer[offer];
      return (n.length > 1 ? n.slice(0, -1).join(', ') + ' and ' + n[n.length - 1] : n[0]) + ' prints are ' + offer + '.';
    }).join(' ');
    var scaled = Object.keys(this.sizeScale).some(function (k) { return k !== '*' && self.sizeScale[k] < sides[0].areaW; });
    if (scaled) txt += this.bagSizes ? ' The preview shows size ' + this.bagRef + '; on smaller sizes your design is scaled down to fit, at the same price.' : ' Big designs are scaled down slightly to fit smaller sizes, at the same price.';
    this.q('[data-pz-size-guide]').textContent = txt;
  };

  /* ----- Preview ----- */

  Personaliser.prototype.renderSideTabs = function () {
    var self = this, wrap = this.q('[data-pz-sidetabs]');
    wrap.innerHTML = '';
    this.data.sides.forEach(function (side) {
      wrap.appendChild(el('button', { type: 'button', class: 'isg-pz__sidetab', 'data-side': side.key, 'aria-pressed': side.key === self.activeSide ? 'true' : 'false', onclick: function () { self.showSide(side.key); } }, [side.name]));
    });
  };

  Personaliser.prototype.showSide = function (key) {
    var self = this;
    var side = this.sidesByKey[key];
    if (!side) return;
    this.activeSide = key;
    var dz = this.currentDesign();
    Array.prototype.forEach.call(this.c.querySelectorAll('.isg-pz__sidetab'), function (b) {
      var k = b.getAttribute('data-side');
      b.setAttribute('aria-pressed', k === key ? 'true' : 'false');
      var count = dz ? dz.prints.filter(function (p) { return p.side === k; }).length : 0;
      b.textContent = self.sidesByKey[k].name + (count ? ' (' + count + ')' : '');
    });
    var garment = this.q('[data-pz-garment]');
    var nophoto = this.q('[data-pz-nophoto]');
    var src = this.viewImage(side);
    var kind0 = this.viewKind(side);
    this.currentSrc = src;
    if (src) {
      if (garment.getAttribute('src') !== src) garment.src = src;
      garment.alt = this.data.productTitle + ' in ' + this.previewColour + ', ' + side.name.toLowerCase() + ' view';
      garment.hidden = false;
      nophoto.hidden = true;
    } else {
      garment.hidden = true;
      garment.removeAttribute('src');
      nophoto.hidden = false;
      this.q('[data-pz-nophoto-title]').textContent = side.name + ' view, ' + this.previewColour;
    }
    var noText = this.q('[data-pz-nophoto-text]');
    if (noText) {
      if (noText.defaultText == null) noText.defaultText = noText.textContent;
      noText.textContent = this.isEnd(side) && !src ? 'We don’t have a photo of the end, so it’s drawn to scale (' + round1(this.endPanel.size.w) + ' × ' + round1(this.endPanel.size.h) + ' cm). The dashed box shows where prints can go.' : noText.defaultText;
    }
    this.c.classList.toggle('is-view-pending', !src && kind0 === 'pending');
    var kind = this.viewKind(side), what = this.isSleeve(side) ? 'sleeve' : 'back';
    if (!src && !this.isSleeve(side)) kind = '';
    this.q('[data-pz-preview-caption]').textContent = 'Design ' + (dz ? dz.id : '') + ' on ' + (this.previewColour || '') +
      (kind === 'made' ? ' – ' + what + ' view made from the front photo' : kind === 'pending' ? ' – preparing the ' + what + ' view…' :
       kind === 'front' ? (what === 'back' ? ' – shown on the front photo (no back photo)' : ' – no sleeve photo for this colour, so the box shows the print area') :
       this.isEnd(side) && !src ? ' – ' + side.name.toLowerCase() + ', drawn to scale' : '');
    this.layoutZone();
    this.renderPreviewPrints();
  };

  // Read a photo's pixels (scaled copy) and measure the garment. null if it can't be read or measured.
  // side: the position the photo is for (a bag end is measured as the end panel); defaults to the main position.
  Personaliser.prototype.measure = function (img, side) {
    try {
      var w = 240, h = Math.max(1, Math.round(w * img.naturalHeight / img.naturalWidth));
      var c = doc.createElement('canvas'); c.width = w; c.height = h;
      var ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, w, h);
      var px = ctx.getImageData(0, 0, w, h).data;
      if (this.isEnd(side)) return bagFit(px, w, h, this.endPanel.size, { w: side.areaW, h: side.areaH }, false, 0.5);
      if (this.bagMode) return this.bag ? bagFit(px, w, h, this.bag.size, this.bag.area, !!this.bagSizes, this.bag.vpos) : null;
      if (this.headwear) { var s0 = this.data.sides[0]; return s0 ? headwearFit(px, w, h, this.headwear, s0.areaW, s0.areaH, this.bodyW()) : null; }
      if (this.legs) { var s1 = this.data.sides[0]; return s1 ? legFit(px, w, h, s1.areaW, s1.areaH, this.bodyW()) : null; }
      if (this.hivis) {
        var s2 = this.data.sides.filter(function (x) { return x.chest === 'left' || x.chest === 'right'; })[0];
        return s2 ? hivisFit(px, w, h, { sleeved: this.hivis === 'hivis-top', longSleeve: this.hivis === 'hivis-long',
          bodyCm: this.bodyW(), areaW: s2.areaW, areaH: s2.areaH }) : null;
      }
      if (this.apron) {
        var s3 = this.data.sides[0], st3 = this.data.settings;
        return s3 ? apronFit(px, w, h, { scaleBy: st3.apronScale === 'width' ? 'width' : 'length', lengthCm: st3.apronSizeCm,
          widthCm: st3.apronSizeCm, areaW: s3.areaW, areaH: s3.areaH, belowCm: s3.below || 0 }) : null;
      }
      return garmentFit(px, w, h, { longSleeve: this.longSleeve, hood: this.hood });
    } catch (e) { return null; }
  };

  // Where the print area sits on a photo: measured from the photo when possible, otherwise the template values.
  Personaliser.prototype.zoneFor = function (side, src) {
    if (!side || side.autoFit === false) return side;
    var f = src === undefined ? this.fits[this.currentSrc] : this.fits[src];
    if (this.isEnd(side)) {
      // An end photo (alt text end:<Colour>) is measured as the end panel; with none, the end is drawn to scale.
      var e = f || endPlace(1000, 1000 / this.stageAspect, this.endPanel.size, { w: side.areaW, h: side.areaH });
      return { zoneLeft: e.zoneLeft, zoneTop: e.zoneTop, zoneWidth: e.zoneWidth, box: e.box, endPanel: !f };
    }
    var use = f || (this.isSleeve(side) ? null : this.lastFit);
    if (!use && this.bagMode && this.bag && !this.isSleeve(side)) use = this.bagDefault(side);
    if (!use) return side;
    // Leg positions: the measured print area on that leg (a photo measured as a whole has one per leg).
    if (this.legs) {
      var lz = use.legs && use.legs[side.leg];
      return lz ? { zoneLeft: lz.zoneLeft, zoneTop: lz.zoneTop, zoneWidth: lz.zoneWidth, box: use.box } : side;
    }
    // Hi-vis chest positions: the measured clear place on that side of the chest.
    if (this.hivis) {
      var hz = use.chest && use.chest[side.chest];
      return hz ? { zoneLeft: hz.zoneLeft, zoneTop: hz.zoneTop, zoneWidth: hz.zoneWidth, box: use.box } : side;
    }
    // Aprons: the measured place already allows for the distance below the top of the bib or waistband.
    if (this.apron) return { zoneLeft: use.zoneLeft, zoneTop: use.zoneTop, zoneWidth: use.zoneWidth, box: use.box };
    // Chest prints sit beside the zip or placket; a print area can start lower down (below a quarter-zip).
    var out;
    if (this.isChest(side)) out = chestZone(use, this.bodyW(), side.chest, side.gap || 0, side.areaW);
    else if (this.isSleeve(side) || !use.box) out = { zoneLeft: use.zoneLeft, zoneTop: use.zoneTop, zoneWidth: use.zoneWidth, box: use.box };
    else {
      // Garment front/back: calibrated scale (print area = areaW cm of the measured garment width, starting the measured
      // cm below the garment top) or, uncalibrated, the body taken as the print area (flagged as estimated).
      var gz = garmentZone(use, side, this.calibValues, this.stageAspect);
      out = { zoneLeft: gz.zoneLeft, zoneTop: gz.zoneTop, zoneWidth: gz.zoneWidth, box: gz.box, estimated: gz.estimated };
      if (gz.error && !this.calibWarned) { this.calibWarned = true; if (root.console) root.console.warn('ISG personaliser: ' + gz.error); }
    }
    if (side.below) out.zoneTop += side.below * out.zoneWidth * this.stageAspect / side.areaW;
    return out;
  };

  // A bag photo that can't be measured (e.g. white on white): measure the product's other colour photos, which are shot
  // the same way, and use the first one that measures flat (else the first angled one). Runs once.
  Personaliser.prototype.referenceFit = function () {
    var self = this;
    if (this.refFitStarted) return;
    this.refFitStarted = true;
    var srcs = this.data.colours.map(function (c) { return c.image; }).filter(function (u, i, a) { return u && a.indexOf(u) === i; });
    var approx = null, i = 0;
    (function next() {
      if (self.lastFit) return;
      if (i >= srcs.length) { if (approx) { self.lastFit = approx; self.layoutZone(); self.renderPreviewPrints(); } return; }
      var src = srcs[i++];
      var done = function (f) {
        if (f && !f.approx) { self.lastFit = f; self.layoutZone(); self.renderPreviewPrints(); return; }
        if (f && !approx) approx = f;
        next();
      };
      if (src in self.fits) return done(self.fits[src]);
      loadImage(src, true).then(function (img) { self.fits[src] = self.measure(img, self.data.sides[0]); done(self.fits[src]); }, function () { done(null); });
    })();
  };

  // A bag photo that can't be measured: the side's left/top/width settings say where the bag body usually sits (in % of
  // the photo); its height follows from the bag size. The print area is placed on that body as for a measured photo.
  // With the "bag centred in the photo" layout (gymsacs, pouches, messengers: no handles above the bag), the bag is centred
  // both ways instead, the width setting as its width (never taller than 80% of the photo), the height from its size.
  Personaliser.prototype.bagDefault = function (side) {
    var W = 1000, H = W / this.stageAspect, b = this.bag.size;
    if ((this.data.settings.bagLayout || '') === 'centred') {
      var cw = Math.min(side.zoneWidth / 100 * W, 0.8 * H * b.w / b.h), ch = cw * b.h / b.w, cl = (W - cw) / 2, ct = (H - ch) / 2;
      return bagPlace({ l: cl, t: ct, r: cl + cw, b: ct + ch }, W, H, b, this.bag.area, this.bag.vpos);
    }
    var l = side.zoneLeft / 100 * W, t = side.zoneTop / 100 * H, bw = side.zoneWidth / 100 * W;
    var bh = Math.min(H - t, bw * b.h / b.w);
    return bagPlace({ l: l, t: t, r: l + bw, b: t + bh }, W, H, b, this.bag.area, this.bag.vpos);
  };

  Personaliser.prototype.layoutZone = function () {
    var side = this.sidesByKey[this.activeSide];
    if (!side) return;
    var zone = this.q('[data-pz-zone]'), zf = this.zoneFor(side);
    zone.style.left = zf.zoneLeft + '%';
    zone.style.top = zf.zoneTop + '%';
    zone.style.width = zf.zoneWidth + '%';
    zone.style.height = (zf.zoneWidth * this.stageAspect * (side.areaH / side.areaW)) + '%';
    var ep = this.q('[data-pz-endpanel]');
    if (ep) {
      var showEp = !!(zf.endPanel && !this.currentSrc && zf.box);
      ep.hidden = !showEp;
      if (showEp) {
        ep.style.left = zf.box.l + '%'; ep.style.top = zf.box.t + '%';
        ep.style.width = (zf.box.r - zf.box.l) + '%'; ep.style.height = (zf.box.b - zf.box.t) + '%';
        ep.classList.toggle('is-round', !!this.endPanel.round);
      }
    }
    this.q('[data-pz-zone-label]').textContent = side.name + ' print area ' + side.areaW + ' × ' + side.areaH + ' cm';
  };

  Personaliser.prototype.renderPreviewPrints = function () {
    var self = this, zone = this.q('[data-pz-zone]');
    Array.prototype.forEach.call(zone.querySelectorAll('.isg-pz__art'), function (n) { n.remove(); });
    var side = this.sidesByKey[this.activeSide];
    var dz = this.currentDesign();
    if (!dz) return;
    dz.prints.forEach(function (p) {
      if (p.side !== self.activeSide || !p.art) return;
      var box = el('div', { class: 'isg-pz__art' + (self.selectedPrint === p.uid ? ' is-selected' : ''), 'data-uid': p.uid, tabindex: '0', role: 'group',
        'aria-label': 'Print ' + p.number + (p.kind === 'text' ? ' text' : ' artwork') + '. Arrow keys move it, plus and minus change its size, square brackets rotate it.' });
      self.placeBox(box, p);
      var bb = p.art.bbox;
      var img = el('img', { src: p.art.url, alt: '', draggable: 'false' });
      img.style.width = (p.art.w / bb.w) * 100 + '%';
      img.style.height = (p.art.h / bb.h) * 100 + '%';
      img.style.left = (-bb.x / bb.w) * 100 + '%';
      img.style.top = (-bb.y / bb.h) * 100 + '%';
      box.appendChild(img);
      box.appendChild(el('span', { class: 'isg-pz__art-tag', text: String(p.number) }));
      box.appendChild(el('span', { class: 'isg-pz__handle', 'data-handle': '', 'aria-hidden': 'true' }));
      box.appendChild(el('span', { class: 'isg-pz__rotate', 'data-rotate': '', 'aria-hidden': 'true', title: 'Rotate' }));
      self.enableDrag(box, p);
      zone.appendChild(box);
    });
  };

  // Where a print may go (review point 4, 18 Oct 2026): always inside the position's approved print area, in cm from
  // its top-left. When the photo was measured the garment outline trims that further (a print can't hang off the
  // hem); when it can't be measured the print area is the template's (or the borrowed) box, still enforced. Chest
  // prints also stay on their own side of the zip or placket. The former "confine" switch no longer loosens this.
  Personaliser.prototype.bounds = function (side) {
    var zf = this.zoneFor(side);
    var b = zf.box ? pctBoxToCm(zf.box, zf, side.areaW, this.stageAspect)
      : stageBounds({ areaW: side.areaW, areaH: side.areaH, zoneLeft: zf.zoneLeft, zoneTop: zf.zoneTop, zoneWidth: zf.zoneWidth }, this.stageAspect);
    if (this.isChest(side)) {
      if (side.chest === 'left') b.x0 = Math.max(b.x0, 0); else b.x1 = Math.min(b.x1, side.areaW);
    }
    b.x0 = Math.max(b.x0, 0); b.y0 = Math.max(b.y0, 0); b.x1 = Math.min(b.x1, side.areaW); b.y1 = Math.min(b.y1, side.areaH);
    // A degenerate outline (narrower than the area start) must never leave a zero or negative box.
    if (b.x1 <= b.x0) { b.x0 = 0; b.x1 = side.areaW; }
    if (b.y1 <= b.y0) { b.y0 = 0; b.y1 = side.areaH; }
    return b;
  };

  /* hand-over to the next part */
  NS.Personaliser = Personaliser;
  NS.__parts = 3;
})(typeof window !== 'undefined' ? window : globalThis);
